import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrReplaceAllRulesRequest = {};
var _createOrReplaceAllRulesResponse = {};
var _empty = {};
var _listRulesRequest = {};
var _listRulesResponse = {};
var _listTemplatesResponse = {};
function resolveWixSocialGroupsApiV2GroupRulesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a group's rules.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function listRules(payload) {
    var _a = serializer(_listRulesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRulesResponse, {}).fromJSON;
    function __listRules(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_rules',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupRulesService.ListRules',
            url: resolveWixSocialGroupsApiV2GroupRulesServiceUrl({
                protoPath: '/v2/rules/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRules.fromReq = fromReq;
    __listRules.__isAmbassador = true;
    return __listRules;
}
/**
 * Creates rules if no rules have been set up. Otherwise, replaces all existing rules.
 *
 * > **Notes:**
 * > + Only group admins can create or replace rules.
 * > + This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function createOrReplaceAllRules(payload) {
    var _a = serializer(_createOrReplaceAllRulesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrReplaceAllRulesResponse, {}).fromJSON;
    function __createOrReplaceAllRules(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_rules',
            method: 'PUT',
            methodFqn: 'wix.social.groups.api.v2.GroupRulesService.CreateOrReplaceAllRules',
            url: resolveWixSocialGroupsApiV2GroupRulesServiceUrl({
                protoPath: '/v2/rules/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrReplaceAllRules.fromReq = fromReq;
    __createOrReplaceAllRules.__isAmbassador = true;
    return __createOrReplaceAllRules;
}
/** Retrieves the rule templates. */
export function listTemplates(payload) {
    var _a = serializer(_empty, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTemplatesResponse, {}).fromJSON;
    function __listTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_rules',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupRulesService.ListTemplates',
            url: resolveWixSocialGroupsApiV2GroupRulesServiceUrl({
                protoPath: '/v2/rules/templates',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTemplates.fromReq = fromReq;
    __listTemplates.__isAmbassador = true;
    return __listTemplates;
}
//# sourceMappingURL=http.impl.js.map